/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerWalletHolds } from '../../axios/customerWalletHolds'
import type {
	CustomerWalletHoldsError,
	CustomerWalletHoldsPathParams,
	CustomerWalletHoldsResponse,
} from '../../types/CustomerWalletHolds'

export const customerWalletHoldsQueryKey = (organisation: CustomerWalletHoldsPathParams['organisation']) =>
	[{ url: '/:organisation/wallet/holds', params: { organisation } }] as const

export type CustomerWalletHoldsQueryKey = ReturnType<typeof customerWalletHoldsQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::holds */
export function customerWalletHoldsQueryOptions(
	organisation: CustomerWalletHoldsPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomerWalletHoldsResponse,
		AxiosError<CustomerWalletHoldsError>,
		CustomerWalletHoldsResponse,
		CustomerWalletHoldsQueryKey
	>({
		queryKey: customerWalletHoldsQueryKey(organisation),
		queryFn: ({ signal }) => customerWalletHolds(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::holds */
export function useCustomerWalletHolds<TSelectData = CustomerWalletHoldsResponse>(
	organisation: CustomerWalletHoldsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomerWalletHoldsResponse,
					AxiosError<CustomerWalletHoldsError>,
					TSelectData,
					CustomerWalletHoldsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomerWalletHoldsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customerWalletHoldsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::holds */
export function useCustomerWalletHoldsSuspense<TSelectData = CustomerWalletHoldsResponse>(
	organisation: CustomerWalletHoldsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomerWalletHoldsResponse,
					AxiosError<CustomerWalletHoldsError>,
					TSelectData,
					CustomerWalletHoldsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomerWalletHoldsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customerWalletHoldsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
